/**
 * Single-row quick filter bar: search (optional left) + multi-select filters (optional right).
 * On md+ keeps one horizontal row; scrolls horizontally if space is tight.
 */
export default function QuickFilterGrid({
  search,
  filters = [],
  /** 'start' = search first (left). 'end' = filters left, search right (legacy). */
  searchPosition = 'start',
  /** When search is 'start': 'end' pushes filters to the right edge of the bar. */
  filtersAlign = 'start',
  searchFlex = 'md:flex-[2] md:min-w-[12rem] md:max-w-[28rem]',
  filterFlex = 'md:flex-1 md:min-w-[6.75rem] md:max-w-[9.5rem]',
  /** Optional per-filter width classes (same length as `filters`). */
  filterFlexes = null
}) {
  const searchNode = search ? (
    <div className={`w-full min-w-0 shrink-0 h-9 flex items-center ${searchFlex}`}>{search}</div>
  ) : null;

  const filterNodes = filters.map((node, i) => (
    <div
      key={i}
      className={`w-full min-w-[8rem] md:w-auto shrink-0 h-9 flex items-center ${
        filterFlexes?.[i] || filterFlex
      }`}
    >
      {node}
    </div>
  ));

  const filtersWrapClass =
    filtersAlign === 'end'
      ? 'flex flex-col gap-2 md:flex-row md:flex-nowrap md:items-center md:gap-1 md:min-w-0 md:ml-auto md:justify-end md:shrink-0'
      : 'flex flex-col gap-2 md:flex-row md:flex-nowrap md:items-center md:gap-1 md:min-w-0 md:flex-1 md:justify-start';

  const rowClass =
    searchPosition === 'end'
      ? 'flex min-w-0 gap-2 md:gap-1 md:items-center md:flex-nowrap flex-col md:flex-row md:justify-between md:w-full'
      : 'flex min-w-0 gap-2 md:gap-1 md:items-center md:flex-nowrap flex-col md:flex-row md:w-full';

  return (
    <div className="overflow-x-auto overflow-y-visible overscroll-x-contain">
      <div className={rowClass}>
        {searchPosition === 'end' ? (
          <>
            <div className={filtersWrapClass}>{filterNodes}</div>
            {searchNode}
          </>
        ) : (
          <>
            {searchNode}
            <div className={filtersWrapClass}>{filterNodes}</div>
          </>
        )}
      </div>
    </div>
  );
}
